import { render, staticRenderFns } from "./PromotionsMetric.vue?vue&type=template&id=125fbf13&scoped=true"
import script from "./PromotionsMetric.vue?vue&type=script&lang=js"
export * from "./PromotionsMetric.vue?vue&type=script&lang=js"
import style0 from "./PromotionsMetric.vue?vue&type=style&index=0&id=125fbf13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fbf13",
  null
  
)

export default component.exports